<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button (click)="scrollToTop()" class="btn btn-gold" ngbTooltip="Haut&nbsp;de&nbsp;page" placement="left"
          aria-label="Remonter en haut de la page">
    <i class="bi bi-chevron-up"></i>
  </button>
</div>
